import { render, staticRenderFns } from "./ViRegisterSchoolIndividual.vue?vue&type=template&id=48a35300&scoped=true"
import script from "./ViRegisterSchoolIndividual.vue?vue&type=script&lang=js"
export * from "./ViRegisterSchoolIndividual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a35300",
  null
  
)

export default component.exports